import React, { useCallback, useEffect, useState } from "react";
import { Popover, PopoverDisclosure, usePopoverState } from "reakit";
import { useMachine } from "@xstate/react";
import QrScanner from "qr-scanner";
import heic2any from "heic2any";
import b64toBlob from "b64-to-blob";

import Dropzone, { useDropzone } from "react-dropzone";
import InputMask from "react-input-mask";
// import ReactTooltip from 'react-tooltip'
import { Tooltip } from "react-tooltip";
import { Icon } from "../SVGsprite/svgsprite";
import styles from "./UploadReceip.module.scss";
import { uploadReceiptMachine } from "../../xstate/upload.machine";
import { Loader } from "../Loader/Loader";
import { Table } from "@/js/modules/Table/Table";
import Arrow from "./arrow.svg";
import { Link } from "react-router-dom";
import apiMethods from "../../api/apiMethods";

export function UploadReceipt({ isClosed }) {
	const [state, send] = useMachine(uploadReceiptMachine);
	const [errorDate, setErrorDate] = useState("");
	const [isProcessing, setIsProcessing] = useState(false);
	/* Предпросмотр загружаемого изображения */

	// const [receiptPreview, setReceiptPreview] = useState("");
	const [paths, setPaths] = useState([]);
	const [images, setImages] = useState([]);
	const [inputFields, setInputFields] = useState([]);
	// const [qrData, setQrData] = useState([]);

	const isHeicFile = file => {
		const heicTypes = ["image/heic", "image/heif"];
		const heicExtensions = [".heic", ".heif"];

		const isHeicByType = heicTypes.includes(file.type);
		const isHeicByExtension = heicExtensions.some(ext =>
			file.name?.toLowerCase().endsWith(ext),
		);

		return isHeicByType || isHeicByExtension;
	};

	const convertPdfToImage = async file => {
		try {
			const response = await apiMethods.uploadVoucher.convertPdfToImage(file);

			console.log("Response:", response);

			// Получаем массив изображений из response.data.files
			const imagesArray = response.data?.files;

			if (!imagesArray || imagesArray.length === 0) {
				throw new Error("Не удалось получить изображение из PDF");
			}

			// Берем первый элемент
			const imageData = imagesArray[0];

			// Получаем base64 строку
			let base64String = imageData.base64;

			if (!base64String) {
				throw new Error("Нет данных изображения в ответе сервера");
			}

			// Убираем префикс если есть
			if (base64String.includes(",")) {
				base64String = base64String.split(",")[1];
			}

			const mimeType = imageData.mime || "image/jpeg";

			// Используем b64-to-blob для конвертации
			const blob = b64toBlob(base64String, mimeType);

			// Создаем File из Blob
			const imageFile = new File(
				[blob],
				imageData.file_name || file.name.replace(/\.pdf$/i, ".jpg"),
				{
					type: mimeType,
					lastModified: Date.now(),
				},
			);

			console.log(
				"✅ PDF converted to image successfully, size:",
				imageFile.size,
			);
			return imageFile;
		} catch (error) {
			console.error("❌ PDF conversion failed:", error);
			throw new Error(
				"Не удалось конвертировать PDF. Пожалуйста, попробуйте другой файл.",
			);
		}
	};

	// Функция для улучшения контраста QR-кода
	const enhanceQRContrast = canvas => {
		const ctx = canvas.getContext("2d");
		const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
		const data = imageData.data;

		// Увеличиваем контраст для лучшего распознавания QR
		for (let i = 0; i < data.length; i += 4) {
			// Преобразуем в grayscale и повышаем контраст
			const brightness = (data[i] + data[i + 1] + data[i + 2]) / 3;
			const enhanced = brightness > 128 ? 255 : 0;
			data[i] = enhanced; // R
			data[i + 1] = enhanced; // G
			data[i + 2] = enhanced; // B
		}

		ctx.putImageData(imageData, 0, 0);
	};
	// Функция конвертации HEIC в JPEG/PNG
	const convertHeicToJpeg = async file => {
		try {
			// Конвертируем HEIC в Blob
			const convertedBlob = await heic2any({
				blob: file,
				toType: "image/jpeg",
				quality: 0.8,
			});

			console.log("✅ HEIC converted successfully!");
			console.log("Converted blob:", {
				type: convertedBlob.type,
				size: convertedBlob.size,
			});

			// Создаем новый File объект
			const convertedFile = new File(
				[convertedBlob],
				file.name.replace(/\.(heic|heif)$/i, ".jpg"),
				{ type: "image/jpeg", lastModified: Date.now() },
			);

			return convertedFile;
		} catch (error) {
			console.error("❌ HEIC conversion failed:", error);
			throw error;
		}
	};

	// Функция для уменьшения изображения перед сканированием
	const resizeImageForScanning = (file) => {
		return new Promise((resolve, reject) => {
			const img = new Image();
			const url = URL.createObjectURL(file);

			img.onload = () => {
				// Вычисляем новые размеры с сохранением пропорций
				let width = img.width;
				let height = img.height;

				// if (width > maxSize || height > maxSize) {
				// 	if (width > height) {
				// 		height = (height * maxSize) / width;
				// 		width = maxSize;
				// 	} else {
				// 		width = (width * maxSize) / height;
				// 		height = maxSize;
				// 	}
				// }

				// Создаем canvas и уменьшаем изображение
				const canvas = document.createElement("canvas");
				canvas.width = width;
				canvas.height = height;
				const ctx = canvas.getContext("2d");
				ctx.drawImage(img, 0, 0, width, height);

				// Конвертируем в blob с высоким качеством
				canvas.toBlob(
					blob => {
						if (blob) {
							const resizedFile = new File([blob], file.name, {
								type: "image/jpeg",
								lastModified: Date.now(),
							});

							URL.revokeObjectURL(url);
							resolve(resizedFile);
						} else {
							reject(new Error("Failed to resize image"));
						}
					},
					"image/jpeg",
					0.9,
				);
			};

			img.onerror = () => {
				URL.revokeObjectURL(url);
				reject(new Error("Failed to load image"));
			};

			img.src = url;
		});
	};

	const isPdfFile = file => {
		const pdfTypes = ["application/pdf"];
		const pdfExtensions = [".pdf"];

		const isPdfByType = pdfTypes.includes(file.type);
		const isPdfByExtension = pdfExtensions.some(ext =>
			file.name?.toLowerCase().endsWith(ext),
		);

		return isPdfByType || isPdfByExtension;
	};

	const uploadConvertedFile = file => {
		const newFile = new File([file], file.name, {
			type: file.type,
			lastModified: Date.now(),
		});

		setImages([newFile]);
		setPaths([URL.createObjectURL(newFile)]);

		send({
			type: "INPUT",
			data: {
				image: [newFile],
			},
		});

		return newFile;
	};

	/* Обработка изменений файлового инпута */

	function handleFileChange(files) {
		// Асинхронная обработка файлов
		const processFiles = async () => {
			setIsProcessing(true);
			const processedFiles = [];

			for (let i = 0; i < files.length; i++) {
				const file = files[i];

				let fileToProcess = file;

				if (isPdfFile(file)) {
					try {
						const convertedImage = await convertPdfToImage(file);

						const dataTransfer = new DataTransfer();
						dataTransfer.items.add(convertedImage);

						const newFiles = Array.from(dataTransfer.files);

						handleFileChange(newFiles, true);
						return;
					} catch (error) {
						console.error("❌ PDF conversion failed:", error);
						alert(error.message);
						continue;
					}
				}

				// 1. Конвертируем HEIC если нужно
				else if (isHeicFile(file)) {
					try {
						fileToProcess = await convertHeicToJpeg(file);
						console.log("✅ HEIC converted");
					} catch (error) {
						console.error("❌ HEIC conversion failed:", error);
						fileToProcess = file;
					}
				}

				if (fileToProcess && !isPdfFile(file)) {
					try {
						fileToProcess = await resizeImageForScanning(fileToProcess);
					} catch (error) {
						console.error("❌ Resize failed:", error);
					}
				}

				if (fileToProcess) {
					processedFiles.push(fileToProcess);
				}
			}

			setIsProcessing(false);

			if (processedFiles.length === 0) {
				alert("Не удалось обработать ни одного файла");
				return;
			}

			// Обновляем previews
			setImages(processedFiles);
			setPaths(processedFiles.map(file => URL.createObjectURL(file)));

			send({
				type: "INPUT",
				data: {
					image: processedFiles,
				},
			});

			// Сканируем QR с улучшением
			let hasScanned = false;

			for (let i = 0; i < processedFiles.length; i++) {
				const file = processedFiles[i];

				console.log("file", file);

				// Пробуем разные методы сканирования
				const scanMethods = [
					// Метод 1: Прямое сканирование
					async () => {
						console.log("  Method 1: Direct scan...");
						return await QrScanner.scanImage(file);
					},
					// Метод 2: Сканирование через canvas с улучшением контраста
					async () => {
						console.log("  Method 2: Canvas with contrast enhancement...");
						return new Promise((resolve, reject) => {
							const img = new Image();
							const url = URL.createObjectURL(file);

							img.onload = () => {
								const canvas = document.createElement("canvas");
								canvas.width = img.width;
								canvas.height = img.height;
								const ctx = canvas.getContext("2d");
								ctx.drawImage(img, 0, 0);

								// Улучшаем контраст
								enhanceQRContrast(canvas);

								canvas.toBlob(
									async blob => {
										if (blob) {
											try {
												const result = await QrScanner.scanImage(blob);
												URL.revokeObjectURL(url);
												resolve(result);
											} catch (err) {
												URL.revokeObjectURL(url);
												reject(err);
											}
										} else {
											URL.revokeObjectURL(url);
											reject(new Error("Failed to create blob"));
										}
									},
									"image/jpeg",
									0.9,
								);
							};

							img.onerror = () => {
								URL.revokeObjectURL(url);
								reject(new Error("Failed to load image"));
							};

							img.src = url;
						});
					},
					// Метод 3: Сканирование с опциями для лучшего распознавания
					async () => {
						return await QrScanner.scanImage(file, {
							returnDetailedScanResult: true,
							inverted: false, // Если QR инвертированный
							maxScans: 5,
						}).then(result => {
							if (result && result.data) {
								return result.data;
							}
							throw new Error("No QR found");
						});
					},
				];

				for (const method of scanMethods) {
					try {
						const result = await method();
						if (result) {
							const qrData =
								typeof result === "string" ? result : result.data || result;

							if (typeof qrData === "string") {
								const qrResult = qrData.split("&");
								const parsedData = qrResult.map(value => value.split("="));
								handleFormFromQr(parsedData);
								hasScanned = true;
								break;
							}
						}
					} catch (error) {
						console.log(
							`  Method ${scanMethods.indexOf(method) + 1} failed:`,
							error.message,
						);
					}
				}

				if (hasScanned) break;
			}

			setInputFields(true);
		};

		// Функция обработки данных из QR
		const handleFormFromQr = data => {
			data.forEach(value => {
				const [key, val] = value;

				if (key === "fn") {
					send({ type: "INPUT", data: { fn: val } });
				}

				if (key === "fp") {
					send({ type: "INPUT", data: { fp: val } });
				}

				if (key === "i") {
					send({ type: "INPUT", data: { fd: val } });
				}

				if (key === "s") {
					send({ type: "INPUT", data: { sum: val } });
				}

				if (key === "t") {
					const chDate = val.split("T")[0].split("");
					const chTime = val.split("T")[1].split("");

					const timeValue = `${chTime[0] + chTime[1]}:${chTime[2]}${chTime[3]}`;
					const dateValue = `${chDate[6] + chDate[7]}.${chDate[4]}${chDate[5]}.${chDate[0]}${chDate[1]}${chDate[2]}${chDate[3]}`;

					send({ type: "INPUT", data: { time: timeValue } });
					send({ type: "INPUT", data: { date: dateValue } });
				}
			});
		};

		processFiles();
	}

	const isAndroid = /Android/i.test(navigator.userAgent);

	const openCamera = () => {
		const input = document.createElement("input");
		input.type = "file";
		input.accept = "image/*";
		input.capture = "environment";
		input.onchange = e => {
			if (e.target.files && e.target.files.length > 0) {
				handleFileChange(Array.from(e.target.files));
			}
		};
		input.click();
	};

	const openFilePicker = () => {
		const input = document.createElement("input");
		input.type = "file";
		input.accept = "image/*";
		input.onchange = e => {
			if (e.target.files && e.target.files.length > 0) {
				handleFileChange(Array.from(e.target.files));
			}
		};
		input.click();
	};

	function deleteImage(index) {
		images.splice(index, 1);
		setPaths(images.map(file => URL.createObjectURL(file)));

		if (!images.filter(value => value.correct).length) {
			send({
				type: "INPUT",
				data: {
					fd: "",
					fp: "",
					fn: "",
					date: "",
					time: "",
					sum: "",
					images: "",
				},
			});
		}

		if (images.length === 0) {
			setInputFields(false);

			send({
				type: "INPUT",
				data: {
					fd: "",
					fp: "",
					fn: "",
					date: "",
					time: "",
					sum: "",
					images: "",
				},
			});
		}
	}

	function submitForm(event) {
		event.preventDefault();
		send("SUBMIT_FIELDS");
	}

	useEffect(() => {
		document.title = "Зарегистрировать чек | Программа лояльности SK ZIC";
	}, []);

	const [isTableVisible, setIsTableVisible] = useState(false);
	const toggleTable = () => {
		setIsTableVisible(!isTableVisible);
	};
	return (
		<form
			className={styles.uploadingForm}
			onSubmit={event => submitForm(event)}
		>
			{state.matches({ form: "sending_fields" }) && (
				<div className={styles.loading}>
					<Loader />
				</div>
			)}

			{isProcessing && (
				<div className={styles.loading}>
					<Loader />
				</div>
			)}

			<h1>{isClosed ? "Прием чеков завершен!" : "Зарегистрировать чек"}</h1>

			{isClosed ? (
				<>
					<div
						style={{
							textAlign: "center",
							marginTop: "30px",
						}}
					>
						<p>
							Загруженные чеки проверим до 18.12 включительно.
							<br /> Заказать сертификаты можно до 22.12 включительно.
						</p>
						<p>Спасибо за участие!</p>
					</div>
				</>
			) : (
				<>
					<div className={styles.infoWrapper}>
						<div>
							<p>1. Добавьте фото или сфотографируйте чек с продукцией ZIC.</p>

							<p>
								2. Если чек длинный, сделайте несколько последовательных фото.
								<br /> Чек должен быть виден полностью.
							</p>

							<p>
								3. Если на чеке есть QR-код - сделайте фото отдельным кадром.
							</p>

							<p>
								4. Если фото окажется плохого качества - чек принят не будет.
							</p>
							<p>5. Проверка чеков с ошибками занимает больше времени.</p>
						</div>
					</div>

					<div className={styles.mb_main}>
						<div
							className={styles.title_table}
							onClick={toggleTable}
							style={{ cursor: "pointer" }}
						>
							В акции участвуют:{" "}
							<span
								style={{
									display: "inline-block",
									transform: isTableVisible ? "rotate(0deg)" : "rotate(180deg)",
									transition: "transform 0.3s ease-out",
								}}
							>
								<img src="/images/arrow.svg" alt="" />
							</span>
						</div>
						<div
							className={styles.table_custom_css}
							style={{
								maxHeight: isTableVisible ? "1000px" : "0",
								overflow: "hidden",
								transition: "max-height 0.3s ease-out",
							}}
						>
							<Table
								overflow="auto"
								headers={[
									{ field: "name", title: "Наименование" },
									{ field: "volume", title: "Единица измерения" },
									{ field: "price", title: "Количество баллов" },
								]}
								tableData={[
									{ name: "ZIC TOP", volume: "1 литр", price: 25 },
									{ name: "ZIC ZERO", volume: "1 литр", price: 25 },
									{ name: "ZIC X9", volume: "1 литр", price: 20 },
									{ name: "ZIC X7", volume: "1 литр", price: 15 },
									{ name: "ZIC X8", volume: "1 литр", price: 20 },
									{ name: "ZIC ULTRA", volume: "1 литр", price: 25 },
									{ name: "ZIC X9000", volume: "1 литр", price: 25 },
									{ name: "ZIC X8000", volume: "1 литр", price: 20 },
									{ name: "ZIC X7000", volume: "1 литр", price: 15 },
									// { name: "ZIC X8*", volume: "1 литр", price: 20 + "**" },
								]}
								isLoading={false}
							/>
							<p className={styles.ball_title}>1 балл = 1 рубль</p>
							<p style={{ color: "rgba(0, 0, 0, 0.5)" }}>
								* Наименование продукции может быть изменено
								<br />
								** Количество начисляемых баллов может быть изменено
								<br />В акции участвуют чеки с датой продажи не ранее 16
								декабря.
								{/* Чеки с продукцией ZIC X8 принимаются с датой продажи с 01
								октября 2025 года. */}
							</p>{" "}
							<Link
								style={{ color: "rgba(0, 0, 0, 0.5)" }}
								to="https://storage.yandexcloud.net/zictop.public/documents/rules.pdf"
								target="_blank"
							>
								Полные правила
							</Link>
						</div>
					</div>

					{state.matches({ form: "failure" }) && (
						<>
							{state.context.errors.map((item, index) => (
								<div className="errorMessage" key={index}>
									{item}
								</div>
							))}
						</>
					)}

					{state.matches({ form: "success" }) && (
						<div className={styles.successMessage}>
							<div className={styles.successContent}>
								<h2>
									Загрузка чека <br /> прошла успешно
								</h2>

								<Icon
									name="icon-success"
									className={styles.iconSuccess}
									sizeW="172"
									sizeH="172"
								/>
							</div>
						</div>
					)}

					<div className={styles.dropzoneWrapper}>
						{paths.length < 1 && (
							<Dropzone
								className={styles.scanner}
								onDrop={acceptedFiles => handleFileChange(acceptedFiles)}
							>
								{({ getRootProps, getInputProps }) => (
									<section>
										<div {...getRootProps()}>
											<input {...getInputProps()} />

											<div className={styles.scanner}>
												{!isAndroid ? (
													<p>
														Перетащите изображение сюда или сделайте фото чека
													</p>
												) : (
													<>
														<p>Загрузите изображение чека</p>
													</>
												)}

												<div className="formRow">
													{isAndroid ? (
														<div
															style={{
																gap: "10px",
																display: "flex",
																alignItems: "center",
																flexDirection: "column",
															}}
														>
															<button
																type="button"
																className="btn btnPrimary btnForm"
																onClick={e => {
																	e.stopPropagation();
																	openCamera();
																}}
															>
																Сделать фото
															</button>
															<a type="" className="btn btnPrimary btnForm">
																Выбрать из галереи
															</a>
														</div>
													) : (
														<a type="" className="btn btnPrimary btnForm">
															Добавить фото
														</a>
													)}
												</div>
											</div>
										</div>
									</section>
								)}
							</Dropzone>
						)}

						{paths.length > 0 ? (
							<>
								{paths.map((item, index) => (
									<span className={styles.imageWrapper} key={index}>
										<div
											onClick={() => {
												deleteImage(index);
											}}
											className={styles.close}
										>
											<Icon name="icon-close" sizeW="24" sizeH="24" />
										</div>

										<img
											src={item}
											key={index}
											className={styles.image}
											alt=""
										/>
									</span>
								))}
							</>
						) : (
							<></>
						)}
					</div>

					{inputFields === true && (
						<div className={styles.fieldsWrapper}>
							<div className={styles.fields}>
								<p className={styles.fieldsTitle}>
									Перепроверьте или введите данные по чеку вручную
								</p>

								<div className={styles.inputsRow}>
									<div className={styles.formInput}>
										<label htmlFor="fp" className={styles.inputLabel}>
											ФП
											<span id="receipt_fp" className="my-anchor-element">
												<Icon name="icon-question" sizeH="15" sizeW="15" />
											</span>
											<Tooltip
												className={styles.tooltipNote}
												anchorSelect="#receipt_fp"
												place="top-end"
												type="dark"
												effect="float"
											>
												<img src="/images/fp.jpg" alt="ФП" />
											</Tooltip>
										</label>
										<div className="inputWrapper">
											<input
												name="fp"
												id="fp"
												type="text"
												value={state.context.fp}
												inputMode="numeric"
												onChange={event => {
													send({
														type: "INPUT",
														data: {
															fp: event.target.value,
														},
													});
												}}
											/>
										</div>

										{state.context.fpError && (
											<div className="errorMessage" aria-live="polite">
												<span className="visuallyHidden">
													Ошибка в поле Фискальный признак документа:
												</span>
												{state.context.fpError}
											</div>
										)}
									</div>

									<div className={styles.formInput}>
										<label htmlFor="fn" className={styles.inputLabel}>
											ФН
											<span id="receipt_fn">
												<Icon name="icon-question" sizeH="15" sizeW="15" />
											</span>
											<Tooltip
												className={styles.tooltipNote}
												anchorSelect="#receipt_fn"
												place="top-end"
												type="dark"
												effect="float"
											>
												<img src="/images/fn.jpg" alt="ФН" />
											</Tooltip>
											{/* <ReactTooltip className={styles.tooltipNote} id="receipt_fn" place="top" type="dark" effect="float">
                                    <img src="/images/fn.jpg" alt="ФН"/>
                                </ReactTooltip> */}
										</label>
										<div className="inputWrapper">
											<InputMask
												name="fn"
												id="fn"
												type="text"
												mask="9999999999999999"
												placeholder="XXXXXXXXXXXXXXXX"
												value={state.context.fn}
												inputMode="numeric"
												onChange={event => {
													send({
														type: "INPUT",
														data: {
															fn: event.target.value,
														},
													});
												}}
											/>
										</div>

										{state.context.fnError && (
											<div className="errorMessage" aria-live="polite">
												<span className="visuallyHidden">
													Ошибка в поле Номер фискального накопителя:
												</span>
												{state.context.fnError}
											</div>
										)}
									</div>
								</div>

								<div className={styles.inputsRow}>
									<div className={styles.formInput}>
										<label htmlFor="fd" className={styles.inputLabel}>
											ФД
											{/* data-tip
                                data-for="receipt_fd" */}
											<span id="receipt_fd">
												<Icon name="icon-question" sizeH="15" sizeW="15" />
											</span>
											<Tooltip
												className={styles.tooltipNote}
												anchorSelect="#receipt_fd"
												place="top-end"
												type="dark"
												effect="float"
											>
												<img src="/images/fd.jpg" alt="ФД" />
											</Tooltip>
											{/* <ReactTooltip className={styles.tooltipNote} id="receipt_fd" place="top" type="dark" effect="float">
                                    <img src="/images/fd.jpg" alt="ФД"/>
                                </ReactTooltip> */}
										</label>
										<div className="inputWrapper">
											<input
												name="fd"
												id="fd"
												value={state.context.fd}
												type="text"
												inputMode="numeric"
												onChange={event => {
													send({
														type: "INPUT",
														data: {
															fd: event.target.value,
														},
													});
												}}
											/>
										</div>

										{state.context.fdError && (
											<div className="errorMessage" aria-live="polite">
												<span className="visuallyHidden">
													Ошибка в поле Номер Фискального Документа:
												</span>
												{state.context.fdError}
											</div>
										)}
									</div>

									<div className={styles.formInput}>
										<label htmlFor="date" className={styles.inputLabel}>
											Дата покупки
											<span id="receipt_date">
												<Icon name="icon-question" sizeH="15" sizeW="15" />
											</span>
											<Tooltip
												className={styles.tooltipNote}
												anchorSelect="#receipt_date"
												place="top-end"
												type="dark"
												effect="float"
											>
												<img src="/images/date.jpg" alt="Дата" />
											</Tooltip>
											{/* <ReactTooltip className={styles.tooltipNote} id="receipt_date" place="top" type="dark" effect="float">
                                    <img src="/images/date.jpg" alt="Дата"/>
                                </ReactTooltip> */}
										</label>
										<div className="inputWrapper">
											<InputMask
												id="date"
												name="date"
												type="text"
												mask="99.99.9999"
												placeholder="ДД.ММ.ГГГГ"
												value={state.context.date}
												onChange={event => {
													setErrorDate("");
													const inputDate = event.target.value;
													const [day, month, year] = inputDate
														.split(".")
														.map(Number);
													const inputDateObj = new Date(year, month - 1, day);

													const currentDate = new Date();
													const cutoffDate = new Date(2025, 0, 1); // 1 января 2025 года

													if (
														inputDateObj < cutoffDate ||
														inputDateObj > currentDate
													) {
														setErrorDate(
															`Дата должна быть не ранее 01.01.2025 и не позже текущей даты. (Подробнее в п. 2.1.7 <a
                                                                    
                                                                    href="https://storage.yandexcloud.net/zictop.public/documents/rules.pdf"
                                                                    target='__blank'
                                                                >Правил</a>)`,
														);
													}
													send({
														type: "INPUT",
														data: {
															date: event.target.value,
														},
													});
												}}
											/>
										</div>
										{errorDate && (
											<div
												className="errorMessage"
												aria-live="polite"
												dangerouslySetInnerHTML={{ __html: errorDate }}
											/>
										)}
										{state.context.dateError && (
											<div className="errorMessage" aria-live="polite">
												<span className="visuallyHidden">
													Ошибка в поле дата покупки:
												</span>
												{state.context.dateError}
											</div>
										)}
									</div>
								</div>

								<div className={styles.inputsRow}>
									<div className={styles.formInput}>
										<label htmlFor="sum" className={styles.inputLabel}>
											Сумма чека
											<span id="receipt_total">
												<Icon name="icon-question" sizeH="15" sizeW="15" />
											</span>
											<Tooltip
												className={styles.tooltipNote}
												anchorSelect="#receipt_total"
												place="top-end"
												type="dark"
												effect="float"
											>
												<img src="/images/total.jpg" alt="Сумма" />
											</Tooltip>
											{/* <ReactTooltip className={styles.tooltipNote} id="receipt_total" place="top" type="dark" effect="float">
                                    <img src="/images/total.jpg" alt="Сумма"/>
                                </ReactTooltip> */}
										</label>
										<div className="inputWrapper">
											<input
												name="sum"
												id="sum"
												type="text"
												placeholder="XXX.XX"
												value={state.context.sum}
												onChange={event => {
													send({
														type: "INPUT",
														data: {
															sum: event.target.value,
														},
													});
												}}
											/>
										</div>

										{state.context.sumError && (
											<div className="errorMessage" aria-live="polite">
												<span className="visuallyHidden">
													Ошибка в поле сумма чека:
												</span>
												{state.context.sumError}
											</div>
										)}
									</div>

									<div className={styles.formInput}>
										<label htmlFor="time" className={styles.inputLabel}>
											Время покупки
											<span id="receipt_time">
												<Icon name="icon-question" sizeH="15" sizeW="15" />
											</span>
											<Tooltip
												className={styles.tooltipNote}
												anchorSelect="#receipt_time"
												place="top-end"
												type="dark"
												effect="float"
											>
												<img src="/images/time.jpg" alt="Время" />
											</Tooltip>
											{/* <ReactTooltip className={styles.tooltipNote} id="receipt_time" place="top" type="dark" effect="float">
                                    <img src="/images/time.jpg" alt="Время"/>
                                </ReactTooltip> */}
										</label>
										<div className="inputWrapper">
											<InputMask
												name="time"
												id="time"
												type="text"
												mask="99:99"
												placeholder="00:00"
												value={state.context.time}
												onChange={event => {
													send({
														type: "INPUT",
														data: {
															time: event.target.value,
														},
													});
												}}
											/>
										</div>
										{state.context.timeError && (
											<div className="errorMessage" aria-live="polite">
												<span className="visuallyHidden">
													Ошибка в поле время покупки:
												</span>
												{state.context.timeError}
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
					)}

					{inputFields === true && (
						<div className="formRow">
							<button
								type="submit"
								disabled={
									errorDate !== "" ||
									!state.context.fd ||
									!state.context.fn ||
									!state.context.fp ||
									!state.context.date ||
									!state.context.time ||
									!state.context.sum ||
									!state.context.image
								}
								className="btn btnPrimary btnForm"
							>
								Отправить чек
							</button>
						</div>
					)}
				</>
			)}
		</form>
	);
}
